import type { DailyClub } from './clubs';
import { escapeSignInText as escape } from './sign-in-form';

export function renderClubListItem(club: DailyClub): string {
  const status = club.room?.status === 'completed' ? 'Today complete' : club.startsOn > club.day ? 'Starts tomorrow' : 'Daily Club';
  return `<li class="saved-room-item club-list-item">
    <div class="saved-room-heading"><h3 class="saved-room-title">${escape(club.challengeSnapshot.title)}</h3><span class="round-badge">${status}</span></div>
    <p class="saved-room-sub">${club.room ? `${club.room.currentPoints}/${club.room.requiredPoints} team pts · ` : ''}${club.members.length} ${club.members.length === 1 ? 'member' : 'members'} · Midnight (${escape(club.timezone)})</p>
    ${club.leavesOn ? '<p class="card-copy">Leaving at the next midnight.</p>' : ''}
    <div class="saved-room-actions"><a class="btn club-open" href="/?clubId=${encodeURIComponent(club.id)}" data-club-id="${escape(club.id)}">Open Club</a></div>
  </li>`;
}

export function renderClubDetails(club: DailyClub, notice = ''): string {
  return `<section class="club-details" aria-label="Daily Club membership">
    <p class="card-copy"><strong>Daily Club</strong> · ${escape(club.day)} · Resets at midnight (${escape(club.timezone)}).</p>
    ${club.room?.completed ? '<p class="card-copy">Today is complete. Your next workout starts at midnight.</p>' : ''}
    ${club.leavesOn ? '<p class="card-copy">You’re leaving at the next midnight. Today’s activity and rewards remain available.</p>'
      : '<button class="btn-secondary leave-club-btn" type="button">Leave Club</button>'}
    <p class="card-copy" role="status" data-club-notice>${escape(notice)}</p>
  </section>`;
}
